import { useCallback, useState } from 'react';
import axios from 'axios';
import { API_URL } from '../../constants';

export function useLoanApplication() {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const submit = useCallback(async (formData) => {
    setSubmitting(true);
    setError(null);
    try {
      const response = await axios.post(
        `${API_URL}api/CompanyLoanApplications/CreateWithUser`,
        formData,
        { headers: { 'Content-Type': 'application/json' } }
      );
      return response.data;
    } catch (err) {
      console.error(err);
      setError('Yrityslainapyynnön lähettäminen epäonnistui.');
      return null;
    } finally {
      setSubmitting(false);
    }
  }, []);

  return { submit, submitting, error, setError };
}
